import { URLs } from "@/constants";
import EditPrivacyPolicy from "@/views/Admin/EditPrivacyPolicy.vue";
import EditPrompt from "@/views/Admin/EditPrompt.vue";
import EditTermsOfService from "@/views/Admin/EditTermsOfService.vue";
import AccountEditView from "@/views/Auth/AccountEditView.vue";
import ConfirmPasswordResetView from "@/views/Auth/ConfirmPasswordResetView.vue";
import ConfirmRegisterView from "@/views/Auth/ConfirmRegisterView.vue";
import LoginView from "@/views/Auth/LoginView.vue";
import PasswordResetView from "@/views/Auth/PasswordResetView.vue";
import RegisterView from "@/views/Auth/RegisterView.vue";
import SSOProviderView from "@/views/Auth/SSOProviderView.vue";
import CallbackView from "@/views/Callback/CallbackView.vue";
import CustomerListView from "@/views/Customer/CustomerListView.vue";
import DashboardView from "@/views/Dashboard/DashboardView.vue";
import HomeView from "@/views/Home/HomeView.vue";
import PrivacyPolicyView from "@/views/PrivacyPolicy/PrivacyPolicyView.vue";
import ProfileView from "@/views/Profile/ProfileView.vue";
import ReportListView from "@/views/Report/ReportListView.vue";
import UsageDashboardView from "@/views/Usage/UsageDashboardView.vue";
import SourceSync from "@/views/Source/SourceSync.vue";
import SourceConnectView from "@/views/SourceConnect/SourceConnectView.vue";
import TermsOfServicesView from "@/views/TermsOfServices/TermsOfServicesView.vue";
import { createRouter, createWebHistory } from "vue-router";
import CustomerEditView from "@/views/Customer/CustomerEditView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: URLs.PAGE_CUSTOMER_DASHBOARD(),
      name: "dashboard",
      component: DashboardView
    },
    { path: URLs.PAGE_SOURCE_EDIT(), name: "source-edit", component: AccountEditView },
    { path: URLs.PAGE_CUSTOMER_LIST, name: "customer-list", component: CustomerListView },
    { path: URLs.PAGE_CUSTOMER_EDIT(), name: "customer-edit", component: CustomerEditView },
    { path: URLs.PAGE_HOME, name: "home", component: HomeView },
    { path: URLs.PAGE_PRIVACY, name: "privacy", component: PrivacyPolicyView },
    { path: URLs.PAGE_TERMS, name: "terms", component: TermsOfServicesView },
    {
      path: URLs.PAGE_AUTH_LOGIN,
      name: "login",
      component: LoginView
    },
    {
      path: URLs.PAGE_AUTH_REGISTER,
      name: "register",
      component: RegisterView
    },
    {
      path: URLs.PAGE_AUTH_CONFIRM_REGISTER,
      name: "confirm-register",
      component: ConfirmRegisterView
    },
    {
      path: URLs.PAGE_AUTH_PASSWORD_RESET,
      name: "password-reset",
      component: PasswordResetView
    },
    {
      path: URLs.PAGE_AUTH_CONFIRM_PASSWORD_RESET,
      name: "confirm-password-reset",
      component: ConfirmPasswordResetView
    },
    {
      path: URLs.PAGE_AUTH_SSO_PROVIDER,
      name: "sso-provider",
      component: SSOProviderView
    },
    {
      path: URLs.PAGE_CUSTOMER_SOURCES(),
      name: "sources",
      component: CustomerEditView
    },
    {
      path: URLs.PAGE_CALLBACK,
      name: "callback",
      component: CallbackView
    },
    {
      path: URLs.PAGE_SOURCE_CONNECT(),
      name: "source-connect",
      component: SourceConnectView
    },
    {
      path: URLs.PAGE_SYNC_MONITOR(),
      name: "source-sync-monitor",
      component: SourceSync
    },
    {
      path: URLs.ADMIN.PAGE_PRIVACY_POLICY_EDIT,
      name: "admin/privacy-policy-edit",
      component: EditPrivacyPolicy
    },
    {
      path: URLs.ADMIN.PAGE_REPORT_PROMPT_EDIT,
      name: "admin/report-prompt-edit",
      component: EditPrompt
    },
    {
      path: URLs.ADMIN.PAGE_TERMS_OF_SERVICE_EDIT,
      name: "admin/terms-of-service-edit",
      component: EditTermsOfService
    },
    {
      path: URLs.PAGE_REPORT_LIST,
      name: "report-list",
      component: ReportListView
    },
    {
      path: URLs.PAGE_USAGE_DASHBOARD,
      name: "usage-dashboard",
      component: UsageDashboardView
    },
    {
      path: URLs.PAGE_PROFILE,
      name: "profile",
      component: ProfileView
    }
  ]
});

export default router;
